export enum AptType {
    appointment = 'tatouage' as any,
    touchUp = 'retouche' as any,
    consultation = 'consultation' as any,
    unavailable = 'indisponible' as any,
}
